<template>
  <div class='coupon-area'>
    <div class='shop-list' v-if="floorData.data.length > 0" :id='floorData.data[0]["floorId"]' >
      <div class='shop-header' v-if="floorData.titleIsShow !== '1' || floorData.isMore === '0'">
        <div style="float:left" class='title' v-if="floorData.titleIsShow !== '1'">{{ floorData.floorTitle }}</div>
        <a
          style="float:right;line-height: 0.15rem;"
          v-if="floorData.isMore === '0'"
          :href="!$isIframe ? floorData.moreUrl : 'javascript:void(0);'"
          class='more'>查看更多 &gt;</a>
      </div>
      <div class='coupon-list'>
        <div :class="{'shop-item': item.couponBus === '1'}" v-for='(item,index) in floorData.data[0].platCouponList' :key='index' class='coupon-item' @click="goDetails(item)">
          <div
            v-if="item.stockAmount === '0'"
            style='position: absolute;z-index: 90;background: rgba(153,153,153,0.5);width: 100%;height: 100%;display: flex;align-items: center;justify-content: center'>
            <img style='width: 1rem;height: 1rem' src='@/assets/img/soldout.png' alt='' />
          </div>
          <div class='coupon-header' style='z-index: 100'>
            <template v-if="item.couponType === '3'">
              满折券
            </template>
            <template v-else>
              {{ item.couponType === '1' ? '满减券' : '无门槛' }}
            </template>
          </div>
          <div class='coupon-available-box-body'>
            <a :href='Number(item.couponBus) > 0 && !$isIframe ? item.issueStoreUrl : "javascript:void(0);"'>
              <div class='shop-name'>
                {{item.couponBus === '0' ? item.couponName : item.issueStoreName}} <van-icon v-if='Number(item.couponBus) > 0' name="arrow"/>
              </div>
            </a>

            <div class='coupon-info'>
              <template v-if="item.couponType === '3'">
                   <span class='price' style="margin-right:0">{{ item.deductMoney }}</span><span class='unit' style="margin-right:0.05rem;font-size: 0.14rem;font-weight: 700;">折</span>
              </template>
              <template v-else>
                <span class='unit'>￥</span> <span class='price'>{{ item.deductMoney }}</span>
              </template>
              <span v-if="item.couponType === '1' || item.couponType === '3'" class='detail'>满{{ item.lowestMoney }}可用</span>
              <template v-if="item.targetUser==2">
                <template v-if="item.mallNewUser">
                  <div class='address-new' v-if="($moment().isSameOrAfter($moment(item.startReceiveTime)) && item.couponBus === '0') || ($moment().isSameOrAfter($moment(item.startReceiveTime)) && item.couponBus === '1')" :class="{'is-get':item.isGet,'gray':item.receiveStatus !== '1'}" @click.stop='handleReceiveCoupon(item)'>
                    {{ item.isGet ? '已领取' : '立即领取' }}
                  </div>
                  <div class="receive-time" v-else>
                    <p>领取时间</p>
                    <p>{{ $moment(item.startReceiveTime).format('YYYY-MM-DD') }}</p>
                    <p>{{ $moment(item.startReceiveTime).format('HH:mm:ss') }}</p>
                  </div>
                </template>
                <div class='address-new gray' v-else >仅限新人领取</div>
              </template>
              <template v-else>
                <div class='address-new' v-if="($moment().isSameOrAfter($moment(item.startReceiveTime)) && item.couponBus === '0') || ($moment().isSameOrAfter($moment(item.startReceiveTime)) && item.couponBus === '1')" :class="{'is-get':item.isGet,'gray':item.receiveStatus !== '1'}" @click.stop='handleReceiveCoupon(item)'>
                  {{ item.isGet ? '已领取' : '立即领取' }}
                </div>
                <div class="receive-time" v-else>
                  <p>领取时间</p>
                  <p>{{ $moment(item.startReceiveTime).format('YYYY-MM-DD') }}</p>
                  <p>{{ $moment(item.startReceiveTime).format('HH:mm:ss') }}</p>
                </div>
              </template>
            </div>
<!--            <template v-if="Array.isArray(item.useRule)">-->
<!--              <template v-for="(Citem,index) in item.useRule">-->
<!--                <div-->
<!--                  class='coupon-other'-->
<!--                  v-if='index === 0 || Citem.show'-->
<!--                  :key="'rule' + index"-->
<!--                  @click='handleCouponOtherClick(item.useRule,index)'-->
<!--                >-->
<!--                    {{ Citem.label }} <van-icon v-if='index === 0' :name="Citem.show ? 'arrow-down':'arrow'"/>-->
<!--                </div>-->
<!--              </template>-->

<!--            </template>-->
            <div class='coupon-other' >
<!--              {{ item.busUseRule ? '*' + item.busUseRule : '' }}-->
              *具体使用规则请点击查看 <van-icon :name="'arrow'"/>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import { Toast } from 'vant'
import { receiveCoupon, receiveShopCoupon } from '@/api/floor'
export default {
  name: 'couponArea',
  props: ['floorData'],
  data() {
    return {
      useRules: []
    }
  },
  mounted() {
    if (this.floorData.data && Array.isArray(this.floorData.data) && this.floorData.data.length > 0) {
      this.floorData.data.forEach(item => {
        if (item.platCouponList && Array.isArray(item.platCouponList)) {
          item.platCouponList.forEach(Citem => {
            Citem.lowestMoney = this.$NP.divide(Citem.lowestMoney, 100)
            if (Citem.couponType !== '3') {
              Citem.deductMoney = this.$NP.divide(Citem.deductMoney, 100)
            }
            if (Citem.busUseRule) {
              this.$set(Citem, 'useRule', this.IsJsonString(Citem.busUseRule) ? JSON.parse(Citem.busUseRule) : Citem.busUseRule)
            }
            /* this.$set(Citem, 'useRule', [
              { label: '212121' },
              { label: '212121' },
              { label: '212121' }
            ]) */
          })
        }
      })
    }
  },
  methods: {
    IsJsonString(str) {
      try {
        JSON.parse(str)
      } catch (e) {
        return false
      }
      return true
    },
    handleCouponOtherClick(rules, index) {
      if (index === 0) {
        rules.forEach(item => {
          this.$set(item, 'show', !item.show)
        })
      }
    },
    handleReceiveCoupon(row) {
      if (this.$isIframe || row.isGet || row.receiveStatus !== '1' || row.stockAmount === '0') {
        return false
      }
      this.$toast.loading({
        duration: 0,
        message: '领取中...',
        forbidClick: true,
        overlay: false
      })

      if (row.couponBus === '1') { // 店铺券
        const data = {
          couponId: row.couponNumber,
          isNewReceive: row.isNewReceive,
          isShopCoupon: row.isShopCoupon
        }
        receiveShopCoupon(data).then(res => {
          if (res.code === 200) {
            this.$toast.clear()
            this.$set(row, 'isGet', true)
            Toast('领取成功')
          }
        }).catch(() => {
          this.$toast.clear()
        })

        return false
      }
      const transScene = row.couponBus === '0' ? 'platform' : 'instore'

      receiveCoupon({
        couponNumber: row.couponNumber,
        ticketNums: 1,
        transScene: transScene
      }).then(res => {
        if (res.code === 200) {
          this.$toast.clear()
          this.$set(row, 'isGet', true)
          Toast('领取成功')
        }
      }).catch(() => {
        this.$toast.clear()
      })
    },
    goDetails(row) {
      if (row.targetUser == 2 && !row.mallNewUser) return //限新人不是新用户不能领取
      if (this.$isIframe || row.stockAmount === '0') {
        return false
      }
       if (Number(row.couponBus) > 0) {
        location.href = row.couponDetailUrl // 店铺券详情
      } else {
        location.href = this.$config.couponDetailUrl + row.id // 平台券详情
      }
    }
  }
}
</script>

<style lang='scss' scoped>
.coupon-area {
  padding-top: 0.1px;
}

.shop-list {
  margin-top: 0.25rem;
  //margin-bottom: 0.2rem;
  padding: 0rem 0.2rem;
  /*background-color: #fff;*/
}

.shop-header {
  // display: flex;
  // align-items: center;
  // justify-content: space-between;
  // margin-bottom: 0.28rem;
  height: 0.46rem;

  .title {
    //font-size: 0.15rem;
    font-size: 0.18rem;
    color: #333;
    font-weight: 800;
  }

  .more {
    font-size: 0.12rem;
    color: #999;
  }
}
.shop-item{
  .coupon-header{
    background-image: url(../../assets/img/shop-coupon-headerbg.png);
  }
  .coupon-info{
    color: #2595FA;
  }
  .address-new{
    background:linear-gradient(to right, #4FAEFF 2%, #2595FA 100%);
    &.is-get{
      // background: #ccc;
        background:none;
        border: 1px solid #2595FA;
        color: #2595FA;
    }
    &.gray{
      background: #ccc;
    }
  }

}
  .coupon-info .receive-time{
    position: absolute;
    top:0;
    right:0.5rem;
    text-align: center;
    font-size: 0.14rem;
    p{
      margin-bottom: 0.05rem;
    }
  }
.gray {
  background: #ccc;
}

.is-get{
  background:none;
  border: 1px solid #ff2620;
  color: #ff2620;
}

</style>
